var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExceptionalroi = function SvgExceptionalroi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exceptionalroi_svg__a)",
    d: "M47.127 93.749C21.277 93.749.248 72.723.248 46.876S21.278 0 47.128 0C72.97 0 94 21.029 94 46.876c0 11.51-6.126 23.99-10.24 29.568a1.47 1.47 0 0 1-1.082.592c-.478.024-.854-.135-1.153-.442l-2.205-2.285-20.683-20.68a1.47 1.47 0 0 1 0-2.076l3.76-3.762-20.9-5.601L47.1 63.092l4-4.002c.551-.552 1.525-.552 2.073 0l22.639 22.627c.31.308.466.742.428 1.178-.044.434-.279.83-.642 1.077-5.402 3.633-17.475 9.777-28.472 9.777m0-90.817c-24.234 0-43.946 19.713-43.946 43.944 0 24.228 19.712 43.94 43.946 43.94 9.375 0 19.689-4.838 25.325-8.305L52.14 62.201l-4.76 4.765a1.49 1.49 0 0 1-1.416.382 1.48 1.48 0 0 1-1.038-1.039l-6.918-25.814a1.47 1.47 0 0 1 .378-1.417c.367-.37.907-.516 1.417-.378l25.809 6.915c.504.135.9.53 1.038 1.038a1.47 1.47 0 0 1-.382 1.416l-4.518 4.522 20.647 20.683c3.804-5.768 8.671-16.486 8.671-26.398 0-24.231-19.712-43.944-43.94-43.944"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exceptionalroi_svg__b)",
    d: "M47.127 82.26c-19.513 0-35.39-15.874-35.39-35.387 0-19.51 15.877-35.383 35.39-35.383 19.51 0 35.383 15.873 35.383 35.383 0 7.674-2.416 14.973-6.985 21.114a1.467 1.467 0 1 1-2.355-1.75c4.194-5.628 6.408-12.323 6.408-19.361 0-17.894-14.56-32.451-32.45-32.451-17.898 0-32.458 14.557-32.458 32.45 0 17.895 14.56 32.455 32.457 32.455a32.3 32.3 0 0 0 18.146-5.54 1.457 1.457 0 0 1 2.032.396c.455.672.28 1.58-.395 2.032a35.24 35.24 0 0 1-19.783 6.041"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exceptionalroi_svg__c)",
    d: "M47.127 71.262c-13.448 0-24.392-10.938-24.392-24.39 0-13.445 10.94-24.386 24.392-24.386 13.448 0 24.387 10.938 24.387 24.387 0 4.645-1.311 9.16-3.792 13.058a1.465 1.465 0 1 1-2.472-1.575 21.33 21.33 0 0 0 3.334-11.483c0-11.83-9.624-21.454-21.454-21.454-11.833 0-21.46 9.624-21.46 21.454 0 11.832 9.627 21.457 21.46 21.457 3.584 0 7.129-.9 10.249-2.604a1.46 1.46 0 0 1 1.988.583c.39.71.126 1.601-.583 1.988a24.4 24.4 0 0 1-11.657 2.965"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "exceptionalroi_svg__a",
    x1: 47.124,
    x2: 47.124,
    y1: 0,
    y2: 93.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exceptionalroi_svg__b",
    x1: 47.124,
    x2: 47.124,
    y1: 11.489,
    y2: 82.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exceptionalroi_svg__c",
    x1: 47.124,
    x2: 47.124,
    y1: 22.486,
    y2: 71.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28230"
  })))));
};
export default SvgExceptionalroi;